__turbopack_context__.v({
  "dropdown-rewards": "user-profile-module-scss-module__aMQ_5W__dropdown-rewards",
  "dropdown-rewards-with-qr": "user-profile-module-scss-module__aMQ_5W__dropdown-rewards-with-qr",
  "profile-dropdown-menu": "user-profile-module-scss-module__aMQ_5W__profile-dropdown-menu",
  "profile-menu": "user-profile-module-scss-module__aMQ_5W__profile-menu",
  "profile-skeleton": "user-profile-module-scss-module__aMQ_5W__profile-skeleton",
  "qr-code-details": "user-profile-module-scss-module__aMQ_5W__qr-code-details",
  "qr-image": "user-profile-module-scss-module__aMQ_5W__qr-image",
  "rewards": "user-profile-module-scss-module__aMQ_5W__rewards",
  "user": "user-profile-module-scss-module__aMQ_5W__user",
  "user-detail": "user-profile-module-scss-module__aMQ_5W__user-detail",
});
